export function AuthBrandMark(): JSX.Element {
  return (
    <div className="fx-auth-brand-mark">
      <span className="mark">F</span>
      <span>fiscalo</span>
    </div>
  );
}
